import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Container, Tabs, Tab } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SingleSelect from './single-select'
import useMediaQuery from '@mui/material/useMediaQuery'
import { themeV5 } from 'theme/v5'

const AntTabs = (props) => (
  <Tabs
    {...props}
    sx={{
      borderBottom: '1px solid #e8e8e8',
      '& .MuiTabs-indicator': {
        backgroundColor: '#EB0A1E',
      },
    }}/>
)

const AntTab = (props) => (
  <Tab
    disableRipple
    {...props}
    sx={{
      textTransform: 'none',
      minWidth: 72,
      fontWeight: themeV5.typography.fontWeightRegular,
      marginRight: 4,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: themeV5.palette.brand,
        opacity: 1,
      },
      '&.Mui-selected': {
        color: themeV5.palette.brand,
        fontWeight: themeV5.typography.fontWeightMedium,
      },
      '&:focus': {
        color: themeV5.palette.brand,
      },
    }}/>
)

const CustomTabs = ({ tabsConfig, disabled }) => {

  const navigate = useNavigate()
  const [menuIndex, setMenuIndex] = useState(0)
  const mobileView = useMediaQuery('@media (max-width: 600px)')

  useEffect(() => {
    if (tabsConfig && tabsConfig.length > 0) { // to handle on page load to specific tab
      const currentTabIndex = tabsConfig.findIndex(tab => window.location.pathname.includes(tab.path))
      currentTabIndex && currentTabIndex !== -1 ? setMenuIndex(currentTabIndex) : setMenuIndex(0)
    } // eslint-disable-next-line
  }, [window.location.pathname])

  if (!tabsConfig || (tabsConfig && tabsConfig.length === 0))
  {return null}

  const handleChange = (event, index) => !disabled && setMenuIndex(index)

  const onChangeMobileTab = (path) => {
    const tabIndex = tabsConfig.findIndex(tab => tab.path === path)
    setMenuIndex(tabIndex && tabIndex !== -1 ? tabIndex : 0)
    navigate(path)
  }

  const mobileOptions = tabsConfig && tabsConfig.map(tab => ({
    label: tab.label,
    value: tab.path,
  }))

  return (
    <div
      style={{
        marginBottom: -3
      }}>
      {mobileView ? (
        <div
          style={{
            minWidth: '280px',
          }}>
          <SingleSelect
            noNone
            id="site_mobile_menu"
            options={mobileOptions}
            value={mobileOptions[menuIndex].value}
            onChange={onChangeMobileTab}
            disabled={disabled}/>
        </div>
      ) : (
        <Container maxWidth="lg">
          <AntTabs value={menuIndex} onChange={handleChange} aria-label="ant-switch">
            {tabsConfig.map(({ label, path, customOnClick }, key) =>
              <AntTab
                key={key}
                label={label}
                onClick={() => {
                  !disabled && navigate(path)
                  customOnClick && customOnClick()
                }}/>
            )}
          </AntTabs>
        </Container>
      )}
    </div>
  )
}

CustomTabs.propTypes = {
  tabsConfig: PropTypes.array.isRequired,
  loading: PropTypes.bool,
}
export default CustomTabs
